import React from "react"
import { Card, CardBody, Col } from "reactstrap"

function Header() {
  return (
    <Card>
      <CardBody>
        <Col>
          <div className="float-start">
            <h5 className="text-primary">Tenant Channel Configuration</h5>
          </div>
        </Col>
      </CardBody>
    </Card>
  )
}

export default Header
